// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewSwitcher_root__3cJxO","root__button":"ViewSwitcher_root__button__3zF8M","root__button__selected":"ViewSwitcher_root__button__selected__2pQrJ"};